import { useParams } from 'react-router-dom';

import { useAuth } from '../../global/contexts/auth/auth';
import DonoraDetail from '../../features/vacas/layouts/detail';
import VacasOverview from '../../features/vacas/layouts/overview';
import InvestInvitation from '../../features/vacas/layouts/invest-invitation';

// TSS vite/01 — thin page. "Inversiones" — DOS caminos (la page gatea por
// roles_with_data, TSS 01 §import rules):
//  · una vaca (URL con id) → dashboard de esa donadora.
//  · inversionista (donor_owner con datos = tiene % en alguna vaca) → su
//    portafolio (gráfico de inversión + KPI + grilla).
//  · no-inversionista → invitación a invertir.

export default function MisVacasPage() {
    const { donorId } = useParams();
    const { user } = useAuth();

    if (donorId) return <DonoraDetail donorId={donorId} />;

    const isInvestor = Array.isArray(user?.roles_with_data)
        && user.roles_with_data.includes('donor_owner');

    return isInvestor ? <VacasOverview /> : <InvestInvitation />;
}
